// Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
// Main App CSS
import './App.css';
import './animate.css';

import React, { Component } from 'react';
import { UIRouter, UIView } from '@uirouter/react';
import router from './router/router';
import {$state} from './router';
import { connect } from 'react-redux';
import APP_CONST from './constants';
import AppHeader from './components/app-header/app-header';
import AppFooter from './components/app-footer/app-footer';
import { GeckoGlobal } from '@geckolabs/gecko-react-ui';
import { GeckoLogoHeader } from './components';

const LAYOUT_PREFIX = 'global_app_layout_';

export class App extends Component {

    renderFullLayout() {
        if (this.props.layout !== APP_CONST.LAYOUT_FULL) return null;

        const FULL_LAYOUT_BG_COLOR = '#F1F3F5';
        const headerButtons = ($state.current.headerButtons ? $state.current.headerButtons : null);

        return (
            <div id={LAYOUT_PREFIX + APP_CONST.LAYOUT_FULL} style={{backgroundColor: FULL_LAYOUT_BG_COLOR}}>
                
                <AppHeader buttons={headerButtons} />

                <div className="app-body">
                    <UIView />
                </div>

                <AppFooter />

            </div>
        );
    }

    renderPartialLayout() {
        if (this.props.layout !== APP_CONST.LAYOUT_PARTIAL) return null;
        
        return (
            <div id={LAYOUT_PREFIX + APP_CONST.LAYOUT_PARTIAL}>
                <div className="app-body">
                    <GeckoLogoHeader />
                    <UIView />
                </div>

            </div>
        );
    }

    render() {
        const current_page = 'app-page-' + $state.$current.name;

        return (
            <UIRouter router={router}>
                <div id={current_page}>

                    {this.renderFullLayout()}

                    {this.renderPartialLayout()}

                </div>

                <GeckoGlobal />
            </UIRouter>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        layout: store.layout,
        user: store.user || {}
    }
};

export default connect(mapStateToProps)(App);